<template>
  <div class="space-y-4">
    <PriceRangeCard
      :title="$t('Price range')"
      v-model="priceRange"
      :minPrice.number="catalogMinPrice"
      :maxPrice.number="catalogMaxPrice"
      @update:model-value="updatePriceRange"
    />

    <!-- Categories Filter -->
    <UCard v-if="categories.length">
      <template #header>
        <h3 class="text-sm font-semibold">{{ $t('Categories') }}</h3>
      </template>
      <div class="space-y-2">
          <UCheckbox 
            v-for="category in categories" 
              :key="category.id"
              :label="category.name"
              :model-value="filter.categories?.includes(category.id)"
              @update:model-value="(val: boolean | 'indeterminate') => toggleCategory(category.id, val === true)"
          />
      </div>
    </UCard>

    <!-- Badges/Features Filter -->
    <!-- <UCard>
      <template #header>
        <h3 class="text-sm font-semibold">Features</h3>
      </template>
      <div class="space-y-2">
        <div 
          v-for="badge in availableBadges" 
          :key="badge"
          class="flex items-center gap-2"
        >
          <UCheckbox 
            :model-value="localFilters.features.includes(badge)"
            @update:model-value="(val: boolean | 'indeterminate') => toggleBadge(badge, val === true)"
          />
          <label class="text-sm cursor-pointer">{{ badge }}</label>
        </div>
      </div>
    </UCard> -->

    <!-- Rating Filter -->
    <!-- <UCard>
      <template #header>
        <h3 class="text-sm font-semibold">Rating</h3>
      </template>
      <div class="space-y-2">
        <div 
          v-for="rating in ratings" 
          :key="rating"
          class="flex items-center gap-2"
        >
          <UCheckbox 
            :model-value="localFilters.ratings.includes(rating)"
            @update:model-value="(val: boolean | 'indeterminate') => toggleRating(rating, val === true)"
          />
          <div class="flex items-center gap-1">
            <Icon 
              v-for="i in 5" 
              :key="i"
              :name="i <= rating ? 'i-heroicons-star-solid' : 'i-heroicons-star'" 
              class="w-4 h-4 text-yellow-400"
            />
            <span class="text-sm">{{ rating }}+</span>
          </div>
        </div>
      </div>
    </UCard> -->
  </div>
</template>

<script setup lang="ts">
import PriceRangeCard from '../molecules/PriceRangeCard.vue';
import type { CategoryTree, ProductFilter } from '~/types';

const {
  filter,
  catalogMinPrice,
  catalogMaxPrice
} = defineProps<{
  filter: ProductFilter
  hideCategory?: boolean
  catalogMinPrice: number
  catalogMaxPrice: number
  categories: CategoryTree
}>();

const emit = defineEmits<{
  (e: 'update:filter', v: ProductFilter): void
}>()

const priceRange = ref<[number, number]>([filter.minPrice || catalogMinPrice, filter.maxPrice || catalogMaxPrice]);
const selectedCategories = ref<number[]>(filter.categories || []);

// const categories = computed(() => {
//   return filter.categories || [];
// });

// const localFilters = reactive<{
//   categories: string[],
//   features: string[],
//   ratings: number[]
// }>({
//   priceRange: [filter.minPrice, filter.maxPrice],
//   categories: filter.categories,
//   features: filter.features,
//   ratings: filter.ratings
// })

// const availableBadges = ['New', 'Featured', 'Sale', 'Popular', 'Bestseller']
// const ratings = [4, 3, 2, 1]

watch(() => filter, (v) => {
  if (v) {
    priceRange.value = [v.minPrice || catalogMinPrice, v.maxPrice || catalogMaxPrice];
    selectedCategories.value = v.categories || []
  }
})

function toggleCategory(id: number, checked: boolean) {
  if (checked) {
    selectedCategories.value.push(id)
  } else {
    selectedCategories.value = selectedCategories.value.filter((c: number) => c !== id)
  }

  applyFilters();
}

const updatePriceRange = (val: [number, number]) => {
  priceRange.value = val;
  applyFilters();
}

function toggleBadge(badge: string, checked: boolean) {
  // if (checked) {
  //   localFilters.features.push(badge)
  // } else {
  //   localFilters.features = localFilters.features.filter((b: string) => b !== badge)
  // }

  applyFilters();
}

function toggleRating(rating: number, checked: boolean) {
  // if (checked) {
  //   localFilters.ratings.push(rating)
  // } else {
  //   localFilters.ratings = localFilters.ratings.filter((r: number) => r !== rating)
  // }

  applyFilters();
}

function applyFilters() {
  emit('update:filter', {
    ...filter,
    minPrice: priceRange.value[0],
    maxPrice: priceRange.value[1],
    categories: selectedCategories.value,
    // categories: [],
    // features: [],
    // ratings: []
  })
}
</script>

<style scoped>

</style>
